import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchNotificationsApi,
  fetchNotificationByIdApi,
  markNotificationReadApi,
  deleteNotificationApi
} from "../../api/notificationApi";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchNotificationsApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchNotificationById = createAsyncThunk(
  "notifications/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await fetchNotificationByIdApi(id);
      return res.data.data.notification;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const markNotificationRead = createAsyncThunk(
  "notifications/markRead",
  async (id) => {
    await markNotificationReadApi(id);
    return id;
  }
);

export const deleteNotification = createAsyncThunk(
  "notifications/delete",
  async (id) => {
    await deleteNotificationApi(id);
    return id;
  }
);
